import React, { createContext, useContext, useState, useEffect } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const auth = getAuth();
  const db = getFirestore();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [offlineError, setOfflineError] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (authUser) => {
      console.log('Auth State Changed:', authUser); // Debugging line
      if (authUser) {
        try {
          const userDoc = await getDoc(doc(db, 'users', authUser.uid));
          if (userDoc.exists()) {
            const userData = userDoc.data();
            setUser({
              ...authUser,
              fullName: userData?.fullName || authUser.displayName || 'Anonymous',
            });
          } else {
            // If user document does not exist in Firestore
            console.warn('No user document found in Firestore for UID:', authUser.uid);
            setUser({
              ...authUser,
              fullName: authUser.displayName || 'Anonymous',
            });
          }
        } catch (error) {
          console.error('Error fetching user data:', error);
          setOfflineError(true);
          setUser({
            ...authUser,
            fullName: authUser.displayName || 'Anonymous'
          });
        }
      } else {
        setUser(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [auth, db]);

  const value = {
    user,
    loading,
    offlineError
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}